import { Component, HostBinding, Input } from '@angular/core';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';
import { LeaderboardEntry } from '../../../interfaces/leaderboard-entry';

@Component({
  selector: 'leaderboard-card',
  templateUrl: './leaderboard-card.component.html',
  styleUrls: ['./leaderboard-card.component.scss'],
})
export class LeaderboardCardComponent {
  @Input() public leaderboard: LeaderboardEntry;
  @Input() public loading: boolean;
  @Input() public index: number;

  @HostBinding('class.full-view')
  @Input()
  public fullView: boolean;

  @Input() public valueToShow: string;
  @Input() public empty: boolean;

  public showMore = false;

  public currentUser?: UserService['currentUser'];

  constructor(public userService: UserService) {
    this.currentUser = this.userService.currentUser;
  }

  // @computed public get earnedValue() {
  //   if (this.leaderboard) {
  //     const ev = this.leaderboard.statistics.value.current;
  //     return '$' + Number(ev.substring(1, ev.length)).toFixed(2);
  //   }
  // }

  // @computed public get changed() {
  //   if (this.leaderboard) {
  //     const change = this.leaderboard.statistics.value.change;
  //     return parseInt(change).toFixed(0) + '%';
  //   }
  // }

  toggleInfo() {
    this.showMore = !this.showMore;
  }
}
